<template>
  <div class="about-container1">
    <app-navigation></app-navigation>
    <section id="craftsman-philosophy" aria-labelledby="philosophy-heading" class="craftsman-philosophy-section">
      <div class="philosophy-container">
        <div class="philosophy-header">
          <h2 id="philosophy-heading" class="section-title">
            {{ $t('about.philosophy.title') }}
            <span v-html="rawhnkw"></span>
          </h2>
          <p class="section-subtitle">{{ $t('about.philosophy.subtitle') }}</p>
        </div>
        <div class="philosophy-left">
          <div class="mission-card">
            <h3>{{ $t('about.philosophy.eyebrow') }}</h3>
            <p>
              {{ $t('about.philosophy.lead') }}
              <span v-html="rawhxxs"></span>
            </p>
            <p>
              {{ $t('about.philosophy.body') }}
              <span v-html="rawsdiy"></span>
            </p>
          </div>
          <div class="capability-grid">
            <div class="capability-card">
              <div class="capability-icon">
                <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                  <circle r="1" cx="12.1" cy="12.1" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></circle>
                </svg>
              </div>
              <h4>{{ $t('about.philosophy.pillars.precisionRules.title') }}</h4>
              <p>{{ $t('about.philosophy.pillars.precisionRules.text') }}</p>
            </div>
            <div class="capability-card">
              <div class="capability-icon">
                <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                  <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </div>
              <h4>{{ $t('about.philosophy.pillars.automatedChecks.title') }}</h4>
              <p>{{ $t('about.philosophy.pillars.automatedChecks.text') }}</p>
            </div>
            <div class="capability-card">
              <div class="capability-icon">
                <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                  <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="m11 17l2 2a1 1 0 1 0 3-3"></path>
                    <path d="m14 14l2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4"></path>
                    <path d="m21 3l1 11h-2M3 3L2 14l6.5 6.5a1 1 0 1 0 3-3M3 4h8"></path>
                  </g>
                </svg>
              </div>
              <h4>{{ $t('about.philosophy.pillars.shopFriendlyHandoffs.title') }}</h4>
              <p>{{ $t('about.philosophy.pillars.shopFriendlyHandoffs.text') }}</p>
            </div>
            <div class="capability-card">
              <div class="capability-icon">
                <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                  <path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"
                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </div>
              <h4>{{ $t('about.philosophy.pillars.oneClickCnc.title') }}</h4>
              <p>{{ $t('about.philosophy.pillars.oneClickCnc.text') }}</p>
            </div>
          </div>
        </div>
        <div class="philosophy-right">
          <div class="team-panel">
            <figure class="portrait-figure">
              <img alt="Close-up shot of a CNC machine intricately carving wood with precision." src="https://images.pexels.com/photos/7480241/pexels-photo-7480241.jpeg?auto=compress&amp;cs=tinysrgb&amp;h=650&amp;w=940"/>
              <figcaption>
                <div class="about-thq-portrait-backplate-elm">
                  <p class="founder-quote">
                    &quot;{{ $t('about.philosophy.quote') }}&quot;
                    <span v-html="rawxb5x"></span>
                  </p>
                </div>
              </figcaption>
            </figure>
            <div class="trust-badges">
              <div class="badge badge-primary"><span>{{ $t('common.oneClick') }}</span></div>
              <div class="badge badge-secondary"><span>{{ $t('common.restApi') }}</span></div>
              <div class="badge badge-accent">
                <span>{{ $t('common.machinePark') }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="heritage-vision" aria-labelledby="heritage-heading" class="heritage-section">
      <div class="heritage-container">
        <div class="heritage-panel">
          <div class="heritage-headline">
            <h2 id="heritage-heading" class="section-title">
              {{ $t('about.roots.title') }}
              <span v-html="rawjtq2"></span>
            </h2>
            <p class="heritage-lead">
              {{ $t('about.roots.subtitle') }}
              <span v-html="rawa5kl"></span>
            </p>
          </div>
          <div class="heritage-left">
            <div class="intro-content">
              <p class="intro-paragraph">
                {{ $t('about.roots.body') }}
                <span v-html="rawz6h7"></span>
              </p>
            </div>
          </div>
          <div class="heritage-right">
            <div class="proof-card">
              <div class="proof-icon">
                <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                  <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M16 7h6v6"></path>
                    <path d="m22 7l-8.5 8.5l-5-5L2 17"></path>
                  </g>
                </svg>
              </div>
              <div class="proof-content">
                <h3>{{ $t('about.roots.keyMetrics.title') }}</h3>
                <dl>
                  <dt><span>{{ $t('about.roots.keyMetrics.hoursSaved.label') }}</span></dt>
                  <dd><span>{{ $t('about.roots.keyMetrics.hoursSaved.value') }}</span></dd>
                  <dt><span>{{ $t('about.roots.keyMetrics.defectsAvoided.label') }}</span></dt>
                  <dd><span>{{ $t('about.roots.keyMetrics.defectsAvoided.value') }}</span></dd>
                  <dt><span>{{ $t('about.roots.keyMetrics.beneluxClients.label') }}</span></dt>
                  <dd><span>{{ $t('about.roots.keyMetrics.beneluxClients.value') }}</span></dd>
                </dl>
              </div>
            </div>
            <div class="proof-card-featured proof-card">
              <div class="proof-icon">
                <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                  <path d="m16 18l6-6l-6-6M8 6l-6 6l6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </div>
              <div class="proof-content">
                <h3>{{ $t('about.roots.keyMetrics.openIntegration.label') }}</h3>
                <div class="badge-row">
                  <span class="mini-badge">{{ $t('common.restApi') }}</span>
                  <span class="mini-badge">{{ $t('common.machinePark') }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="plan-demo" aria-labelledby="demo-heading" class="demo-section">
      <div class="demo-container2">
        <div class="demo-left">
          <h2 id="demo-heading" class="section-title">{{ $t('about.demo.title') }}</h2>
          <p class="demo-hook">
            <span>
              {{ $t('about.demo.intro') }}
              <span v-html="raw55d1"></span>
            </span>
          </p>
          <div class="demo-timeline">
            <div class="demo-step">
              <div class="step-marker1"><span>1</span></div>
              <div class="step-content">
                <h3>{{ $t('about.demo.steps[0].title') }}</h3>
                <p>{{ $t('about.demo.steps[0].detail') }}</p>
              </div>
            </div>
            <div class="demo-step">
              <div class="step-marker1"><span>2</span></div>
              <div class="step-content">
                <h3>{{ $t('about.demo.steps[1].title') }}</h3>
                <p>{{ $t('about.demo.steps[1].detail') }}</p>
              </div>
            </div>
            <div class="demo-step">
              <div class="step-marker1"><span>3</span></div>
              <div class="step-content">
                <h3>{{ $t('about.demo.steps[2].title') }}</h3>
                <p>{{ $t('about.demo.steps[2].detail') }}</p>
              </div>
            </div>
            <div class="demo-step">
              <div class="step-marker1"><span>4</span></div>
              <div class="step-content">
                <h3>{{ $t('about.demo.steps[3].title') }}</h3>
                <p>{{ $t('about.demo.steps[3].detail') }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="demo-right">
          <div class="demo-benefits-card">
            <h3>{{ $t('about.demo.whatYouGet.title') }}</h3>
            <ul class="benefits-list1">
              <li>
                <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                  <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <span>
                  {{ $t('about.demo.whatYouGet.items[0]') }}
                  <span v-html="raw519z"></span>
                </span>
              </li>
              <li>
                <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                  <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <span>{{ $t('about.demo.whatYouGet.items[1]') }}</span>
              </li>
              <li>
                <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                  <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <span>{{ $t('about.demo.whatYouGet.items[2]') }}</span>
              </li>
              <li>
                <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                  <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <span>
                  {{ $t('about.demo.whatYouGet.items[3]') }}
                  <span v-html="raw2mr6"></span>
                </span>
              </li>
            </ul>
            <div class="who-should-join">
              <h4>{{ $t('about.demo.whoShouldJoin.title') }}</h4>
              <p>
                {{ $t('about.demo.whoShouldJoin.text') }}
                <span v-html="rawq6y1"></span>
              </p>
            </div>
            <div class="demo-badges-row1">
              <span class="mini-badge">{{ $t('common.oneClick') }}</span>
              <span class="mini-badge">{{ $t('common.restApi') }}</span>
              <span class="mini-badge">{{ $t('common.machinePark') }}</span>
            </div>
            <figure class="about-thq-demo-image-elm demo-image">
              <img alt="Detailed view of a CNC machine carving material, showcasing industrial precision." src="https://images.pexels.com/photos/7480239/pexels-photo-7480239.jpeg?auto=compress&amp;cs=tinysrgb&amp;h=650&amp;w=940"/>
            </figure>
            <router-link to="/contactdemo" class="about-thq-btn-elm19 btn btn-primary">
              <button @click="scrollToTop">
                {{ $t('common.scheduleDemo') }}
              </button>
              </router-link>
          </div>
        </div>
      </div>
    </section>
    <app-footer></app-footer>
  </div>
</template>

<script>
import { useHead } from "@vueuse/head";

import AppNavigation from "../components/navigation";
import AppFooter from "../components/footer";

export default {
  name: "About",
  props: {},
  components: {
    AppNavigation,
    AppFooter,
  },
  setup() {
    // Vue 3 migration: move metaInfo into useHead.
    useHead({
      title: "About - KORPUS by VLECAD®",
      meta: [
        {
          name: "description",
          content:
            "KORPUS by VLECAD®: From design to CNC in one click. CAD/CAM that thinks like a craftsman for interior builders and cabinet shops. Book a demo.",
        },
        {
          property: "og:title",
          content: "About - KORPUS by VLECAD®",
        },
        {
          property: "og:description",
          content:
            "KORPUS by VLECAD®: From design to CNC in one click. CAD/CAM that thinks like a craftsman for interior builders and cabinet shops. Book a demo.",
        },
        {
          property: "og:image",
          content:
            "https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/ebedf48f-c2b5-4ca6-808d-9d940905bddf/993061ae-1787-4b73-9fda-47262adc60d9?org_if_sml=1&force_format=original",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://hospitable-imperfect-heron-qlicxu.teleporthq.app/about",
        },
      ],
    });
  },
  mounted() {
    // Vue 3 migration/security: replace injected scripts with lifecycle hooks.
    const cleanupHandlers = [];
    const addListener = (target, event, handler, options) => {
      if (!target) {
        return;
      }
      target.addEventListener(event, handler, options);
      cleanupHandlers.push(() => target.removeEventListener(event, handler));
    };

    const accordionItems = document.querySelectorAll(".accordion-item");
    accordionItems.forEach((item) => {
      const header = item.querySelector(".accordion-header");
      const content = item.querySelector(".accordion-content");
      if (!header || !content) {
        return;
      }
      const handleAccordionClick = () => {
        const isOpen = item.classList.contains("is-open");

        accordionItems.forEach((otherItem) => {
          if (otherItem !== item) {
            otherItem.classList.remove("is-open");
            const otherHeader = otherItem.querySelector(".accordion-header");
            otherHeader?.setAttribute("aria-expanded", "false");
          }
        });

        if (isOpen) {
          item.classList.remove("is-open");
          header.setAttribute("aria-expanded", "false");
        } else {
          item.classList.add("is-open");
          header.setAttribute("aria-expanded", "true");
        }
      };
      addListener(header, "click", handleAccordionClick);
    });

    const searchInput = document.getElementById("faq-search-input");
    const accordionList = document.querySelector(".accordion-list");

    const handleSearchInput = (event) => {
      const searchTerm = event.target.value.toLowerCase();
      const items = accordionList?.querySelectorAll(".accordion-item") || [];

      items.forEach((item) => {
        const header = item.querySelector(".accordion-header span");
        const content = item.querySelector(".accordion-content");
        const text = `${header?.textContent || ""} ${content?.textContent || ""}`.toLowerCase();

        item.style.display = text.includes(searchTerm) ? "" : "none";
      });
    };
    addListener(searchInput, "input", handleSearchInput);

    const demoForm = document.getElementById("demo-form");
    const handleDemoSubmit = (event) => {
      event.preventDefault();

      const formData = new FormData(demoForm);
      const data = Object.fromEntries(formData.entries());

      if (!data.name || !data.company || !data.email || !data.phone) {
        alert("Vul alle verplichte velden in.");
        return;
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(data.email)) {
        alert("Voer een geldig e-mailadres in.");
        return;
      }

      alert("Bedankt voor uw aanvraag! We nemen binnen 24 uur contact met u op om uw demo in te plannen.");
      demoForm.reset();
    };
    addListener(demoForm, "submit", handleDemoSubmit);

    const observerOptions = {
      threshold: 0.1,
      rootMargin: "0px 0px -50px 0px",
    };

    const animateOnScroll = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = "1";
          entry.target.style.transform = "translateY(0)";
        }
      });
    }, observerOptions);

    const elementsToAnimate = document.querySelectorAll(".mission-card, .capability-card, .proof-card, .team-card");
    elementsToAnimate.forEach((element) => {
      animateOnScroll.observe(element);
    });

    this._cleanupAbout = () => {
      cleanupHandlers.forEach((handler) => handler());
      cleanupHandlers.length = 0;
      animateOnScroll.disconnect();
    };
  },
  beforeUnmount() {
    if (this._cleanupAbout) {
      this._cleanupAbout();
    }
  },
  data() {
    return {
      rawhnkw: " ",
      rawhxxs: " ",
      rawsdiy: " ",
      rawxb5x: " ",
      rawjtq2: " ",
      rawa5kl: " ",
      rawz6h7: " ",
      rawwato: " ",
      rawb1oi: " ",
      raw4vaq: " ",
      rawo9ge: " ",
      rawcw9r: " ",
      raw4xvm: " ",
      rawn1td: " ",
      rawvo62: " ",
      rawpwxb: " ",
      rawtk1e: " ",
      raw3sxw: " ",
      rawbqu4: " ",
      rawoqjj: " ",
      rawe4en: " ",
      rawa44l: " ",
      rawzjz4: " ",
      rawq9bo: " ",
      raw427d: " ",
      rawarq1: " ",
      raw4tew: " ",
      rawrb9k: " ",
      rawgllp: " ",
      raw55d1: " ",
      raw8lll: " ",
      rawn7q4: " ",
      rawdfe9: " ",
      raw4roh: " ",
      rawa7io: " ",
      rawyefv: " ",
      rawfx10: " ",
      raw7gnu: " ",
      raw519z: " ",
      raw2mr6: " ",
      rawq6y1: " ",
    };
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }    
  }
};
</script>

<style scoped>
@keyframes fadeSlideIn {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (min-width: 768px) {
  .philosophy-container {
    grid-template-columns: minmax(0, 1fr) 420px;
    column-gap: var(--spacing-4xl);
  }
}
@media (min-width: 768px) {
  .heritage-panel {
    grid-template-columns: 7fr 5fr;
    column-gap: var(--spacing-2xl);
  }
}
@media (min-width: 768px) {
  .micro-timeline {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (min-width: 768px) {
  .timeline-list {
    grid-template-columns: 48% 4% 48%;
  }
  .timeline-list::before {
    content: "";
    position: absolute;
    left: 50%;
    top: 0;
    bottom: 0;
    width: 1px;
    background: var(--color-border);
    transform: translateX(-50%);
  }
}
@media (min-width: 768px) {
  .milestone-left {
    grid-column: 1;
    grid-template-columns: 1fr auto;
    text-align: right;
  }
  .milestone-left .milestone-content {
    order: 1;
  }
  .milestone-left .milestone-marker {
    order: 2;
    grid-column: 2;
  }
  .milestone-right {
    grid-column: 3;
    grid-template-columns: auto 1fr;
  }
  .milestone-cta-bar {
    grid-column: 1 / -1;
  }
}
@media (min-width: 768px) {
  .team-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: var(--spacing-2xl);
  }
}
@media (min-width: 992px) {
  .team-grid {
    grid-template-columns: repeat(3, 1fr);
    column-gap: var(--spacing-3xl);
    row-gap: var(--spacing-2xl);
  }
  .team-card-lead {
    grid-column: 1 / span 2;
    grid-row: 1 / span 2;
  }
}
@media (min-width: 992px) {
  .faq-container {
    grid-template-columns: 1fr 0.6fr;
    gap: var(--spacing-xl);
  }
}
@media (min-width: 992px) {
  .demo-container {
    grid-template-columns: 2fr 1fr;
  }
}
@media (min-width: 768px) {
  .demo-timeline {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (min-width: 768px) {
  .demo-step {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
}
@media (min-width: 768px) {
  .form-row {
    grid-template-columns: 1fr 1fr;
  }
}
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
* {
  transition: background-color var(--animation-duration-fast) var(--animation-curve-primary),
    color var(--animation-duration-fast) var(--animation-curve-primary), border-color var(--animation-duration-fast) var(--animation-curve-primary);
}
</style>

<style scoped>
.about-container1 {
  width: 100%;
  display: block;
  min-height: 100vh;
}

.about-container2 {
  display: none;
}

.about-container3 {
  display: contents;
}

.about-container4 {
  display: none;
}

.about-container5 {
  display: contents;
}

.about-container6 {
  display: none;
}

.about-container7 {
  display: contents;
}

.about-thq-btn-elm10 {
  text-decoration: none;
}

.about-thq-portrait-backplate-elm {
  padding: var(--spacing-md);
  background: var(--color-backplate);
  border-radius: var(--border-radius-sm);
}

.about-thq-btn-elm11 {
  text-decoration: none;
}

.about-thq-proof-card-elm1 {
  display: none;
}

.about-thq-milestones-section-elm {
  display: none;
}

.about-thq-team-section-elm {
  display: none;
}

.about-thq-faq-section-elm {
  display: none;
}

.about-thq-demo-image-elm {
  display: none;
}

.about-thq-btn-elm19 {
  text-decoration: none;
}
</style>
